import { Slider } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
export type Props = {
 selectedYear:number,
 maxValue:number,
 minValue:number,
 setSelectedYearHandler:(year:number)=>void;
}
const DateFilterComponent:React.FC<Props>=({selectedYear,setSelectedYearHandler,maxValue,minValue})=>{
     const { t } = useTranslation();
    
     const handleChange = (
       event: Event,
       newValue: number | number[]
     ) => {
      setSelectedYearHandler(newValue as number)
     };
 
     return(
     <div className="filter-type-container">
         <label>{t("filter_label_year")}</label>
         <div className="date-selection-filter">
         <Box sx={{ width: 252,
    '& .MuiSlider-thumb': {
        borderRadius: '50px',
        borderWidth:'50px',
        width:'17px',
        height:'17px',
        border:'2px solid #286AC7',
        color:"#ffffff"
      },'& .MuiSlider-valueLabelOpen':{
        background: 'transparent',
        color: '#2D363F',
        font: "normal normal bold 16px/19px Open Sans"
      },'& .MuiSlider-track':{
        opacity: '0'
      }
      }}>
        <Slider min={minValue} max={maxValue} value={selectedYear} onChange={handleChange}  aria-label="Default" valueLabelDisplay="on" />
     </Box>
     </div>
     </div>)
}

export default DateFilterComponent